import { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../store/types";
import { Box } from "@mui/material";
import { setOutboundCallerId } from "../../../services/outboundCall";
import SbuxSelect from "../../../components/SbuxSelect";
import SbuxTranslate from "../../../components/SbuxTranslate";
import styles from "../styles";
import useCss from "../../../hooks/useCss";
import {
  getIsOutboundPhoneEnabledSelector,
  getOutboundPhonesSelector,
} from "../../../selectors/userInstanceSelector";
import { getIsCallEndedSelector } from "../../../selectors/outboundCallSelector";

const CallerIdOverlayCcp = () => {
  const isOutboundPhoneEnabled = useAppSelector(
    getIsOutboundPhoneEnabledSelector,
  );
  const outboundPhones = useAppSelector(getOutboundPhonesSelector);
  const isCallEnded = useAppSelector(getIsCallEndedSelector);

  const dispatch = useAppDispatch();
  const classes = useCss(styles);
  const typedOutboundPhones = outboundPhones as
    | Array<{ value: string; description: string }>
    | undefined;
  const [selectedCallerId, setSelectedCallerId] = useState(
    typedOutboundPhones?.[0]?.value || "",
  );

  const outboundCallerIdList =
    typedOutboundPhones?.map((phone) => ({
      value: phone.value,
      name: `${phone.value} - ${phone.description}`,
    })) || [];

  useEffect(() => {
    if (isCallEnded && typedOutboundPhones?.[0]?.value) {
      setSelectedCallerId(typedOutboundPhones[0].value);
    }
  }, [isCallEnded, outboundPhones]);

  const handleCallerIdChange = async (value: string) => {
    if (isOutboundPhoneEnabled) {
      await dispatch(setOutboundCallerId(value));
      setSelectedCallerId(value);
    }
  };
  return (
    <>
      {isOutboundPhoneEnabled && (
        <Box className={classes.overlayDropdownRoot}>
          <Box className={classes.overlayDropdownLabel}>
            <SbuxTranslate>{"Outbound ID:"}</SbuxTranslate>
          </Box>
          <Box className={classes.overlayDropdown}>
            <SbuxSelect
              className={classes.outboundPhoneList}
              menuItems={outboundCallerIdList}
              defaultValue={selectedCallerId}
              value={selectedCallerId}
              handleSelectChange={handleCallerIdChange}
            />
          </Box>
        </Box>
      )}
    </>
  );
};

export default CallerIdOverlayCcp;
